<div class="loader">
  <div class="loader__ring">
    <div class="loader__arc loader__arc--outer"></div>
    <div class="loader__arc loader__arc--inner"></div>
    <div class="loader__dot"></div>
  </div>
  @if (message) {
    <p class="loader__message">{{ message }}</p>
  }
</div>
